import { render } from "./category-levels-assessment-mobile.vue?vue&type=template&id=5df9953e&scoped=true&ts=true"
import script from "./category-levels-assessment-mobile.vue?vue&type=script&lang=ts"
export * from "./category-levels-assessment-mobile.vue?vue&type=script&lang=ts"

import "./category-levels-assessment-mobile.vue?vue&type=style&index=0&id=5df9953e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df9953e"]])

export default __exports__